import Label from "components/Label";
import { useTranslation } from "react-i18next";
import type { AdType } from "../../../@types/sharedSchema";

type ListingMatchAdTypeLabelProps = {
  adType: AdType;
  variant?: "filled" | "outlined" | "ghost";
};

export function ListingMatchAdTypeLabel({ adType, variant }: ListingMatchAdTypeLabelProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Label color={adType === "commercial" ? "secondary" : "warning"} variant={variant}>
      {translate(`listingsMatch.adTypes.${adType}`, { defaultValue: adType })}
    </Label>
  );
}
